import React from 'react';
import { ContextMenu, type ContextMenuItem } from './ContextMenu';

interface TaskContextMenuProps {
  isOpen: boolean;
  x: number;
  y: number;
  taskTitle: string;
  onClose: () => void;
  onViewDetails: () => void;
  onOpenDetailsInNewTab: () => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onDuplicateAs: () => void;
  onShowTaskSummary: () => void;
  onDelete: () => void;
}

export const TaskContextMenu: React.FC<TaskContextMenuProps> = ({
  isOpen,
  x,
  y,
  taskTitle,
  onClose,
  onViewDetails,
  onOpenDetailsInNewTab,
  onEdit,
  onDuplicate,
  onDuplicateAs,
  onShowTaskSummary,
  onDelete,
}) => {
  const items: ContextMenuItem[] = [
    { label: 'View task details', onSelect: onViewDetails },
    { label: 'Open details in new tab', onSelect: onOpenDetailsInNewTab },
    { label: 'Edit task', onSelect: onEdit },
    { label: 'Duplicate task', onSelect: onDuplicate },
    { label: 'Duplicate As...', onSelect: onDuplicateAs },
    { label: 'Show task summary', onSelect: onShowTaskSummary },
    { label: 'Delete task', onSelect: onDelete, tone: 'danger' },
  ];

  return (
    <ContextMenu
      isOpen={isOpen}
      x={x}
      y={y}
      label={`Task actions for ${taskTitle}`}
      items={items}
      onClose={onClose}
    />
  );
};